import { ContentContainer, PageLayout, PageTitle } from "components/layout";

import { auditColumns } from "./components/audit-columns";
import { AuditFilters } from "./components/audit-filters";
import { AuditPeriod } from "./components/audit-period";
import { AuditPagination } from "./components/audit-pagination";
import { AuditTable } from "./components/audit-table";
import { useAuditTrail } from "./hooks/use-audit-trail";
import { AUDIT_LABELS } from "./messages";

const AuditTrail = (): JSX.Element => {
  const trail = useAuditTrail();

  return (
    <PageLayout>
      <div className="flex w-full flex-1 justify-between">
        <PageTitle
          title={AUDIT_LABELS.PAGE_TITLE}
          description={AUDIT_LABELS.PAGE_DESCRIPTION}
        />
        <div className="cursor-pointer">
          <AuditPeriod
            start={trail.filters.start}
            end={trail.filters.end}
            onChange={trail.setPeriod}
          />
        </div>
      </div>

      <ContentContainer className="space-y-4">
        <AuditFilters
          filters={trail.filters}
          onChange={trail.setFilter}
          onClear={trail.clearFilters}
        />

        <AuditTable
          columns={auditColumns}
          data={trail.rows}
          isLoading={trail.isLoading}
        />

        <AuditPagination
          total={trail.total}
          perPage={trail.perPage}
          currentPage={trail.currentPage}
          lastPage={trail.lastPage}
          hasPrevious={trail.hasPrevious}
          hasNext={trail.hasNext}
          onPerPageChange={trail.setPerPage}
          onPrevious={trail.goToPreviousPage}
          onNext={trail.goToNextPage}
        />
      </ContentContainer>
    </PageLayout>
  );
};

export default AuditTrail;
